import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
    dogName: string;
    onReset: () => void;
};

function DogMealHeader({ dogName, onReset }: Props) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: { xs: "stretch", md: "center" },
                justifyContent: "center",
                position: "relative",
                mb: 1,
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 1.5, md: 0 },
            }}
        >
            <Typography
                sx={{
                    fontFamily: QUIZ.font.display,
                    fontWeight: 900,
                    textTransform: "uppercase",
                    fontSize: { xs: "22px", md: "32px" },
                    color: QUIZ.color.ink,
                    textAlign: "center",
                }}
            >
                {dogName || "Your dog"}'s meals
            </Typography>

            <Box
                component="button"
                onClick={onReset}
                onTouchEnd={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onReset();
                }}
                sx={{
                    position: { xs: "relative", md: "absolute" },
                    right: { xs: "auto", md: 0 },
                    top: { xs: "auto", md: "50%" },
                    transform: { xs: "none", md: "translateY(-50%)" },
                    width: { xs: "100%", sm: "fit-content", md: "auto" },
                    mx: { xs: "auto", md: 0 },
                    background: QUIZ.color.cream2,
                    color: QUIZ.color.brown,
                    border: `1px solid ${QUIZ.color.cream3}`,
                    padding: "6px 14px",
                    borderRadius: "999px",
                    fontFamily: QUIZ.font.body,
                    fontWeight: 700,
                    fontSize: "0.85rem",
                    cursor: "pointer",
                    touchAction: "manipulation",
                    userSelect: "none",
                    WebkitUserSelect: "none",
                    WebkitTapHighlightColor: "transparent",
                    transition: "all 0.25s ease",
                    "&:hover": {
                        background: QUIZ.color.cream3,
                        transform: { xs: "none", md: "translateY(-50%) scale(1.07)" },
                        boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
                    },
                    "&:active": {
                        transform: { xs: "none", md: "translateY(-50%) scale(0.96)" },
                    },
                }}
            >
                Reset selections
            </Box>
        </Box>
    );
}

export default memo(DogMealHeader);
